import React from 'react'

const clamp = (value, min, max) => Math.min(Math.max(value, min), max)

const Pagination = ({
  page,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 50],
  className = '',
  rowsPerPageLabel = 'Rows per page',
  showRowsPerPageLabel = true,
  showingLabel = 'Showing',
}) => {
  const totalPages = Math.max(1, Math.ceil(Math.max(totalItems, 0) / Math.max(pageSize, 1)))
  const safePage = clamp(page ?? 1, 1, totalPages)
  const hasItems = totalItems > 0
  const startItem = hasItems ? (safePage - 1) * pageSize + 1 : 0
  const endItem = hasItems ? Math.min(safePage * pageSize, totalItems) : 0
  const canGoPrev = safePage > 1
  const canGoNext = safePage < totalPages
  const showPageSizeSelector = typeof onPageSizeChange === 'function' && pageSizeOptions?.length

  return (
    <div
      className={`flex flex-col gap-3 p-3 sm:flex-row sm:items-center sm:justify-between bg-white/5 ${className}`}
    >
      <div className="text-xs sm:text-sm dark:text-white/70 text-customBlack/70">
        {showingLabel} {hasItems ? `${startItem}-${endItem}` : '0-0'} of {totalItems}
      </div>
      <div className="flex items-center gap-3">
        {showPageSizeSelector ? (
          <div className="flex items-center gap-2 text-xs sm:text-sm">
            {showRowsPerPageLabel ? (
              <span className="dark:text-white/70 text-customBlack/70">{rowsPerPageLabel}</span>
            ) : null}
            <select
              value={pageSize}
              onChange={(event) => {
                const newSize = Number(event.target.value)
                if (!Number.isNaN(newSize) && newSize > 0) {
                  onPageSizeChange(newSize)
                }
              }}
              aria-label={rowsPerPageLabel}
              className="rounded-md bg-transparent px-2 py-1 ring-1 dark:ring-white/10 ring-customBlack/20 outline-none dark:text-white text-customBlack"
            >
              {pageSizeOptions.map((size) => (
                <option
                  key={size}
                  value={size}
                  className="dark:bg-custom_dark_primary bg-customFontMilkWhite dark:text-white text-customBlack"
                >
                  {size}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={() => onPageChange?.(safePage - 1)}
            className="rounded-md px-2 py-1 text-sm dark:text-white/80 text-customBlack/80 hover:bg-white/10 disabled:opacity-40"
            disabled={!canGoPrev}
            aria-label="Previous page"
          >
            {'<'}
          </button>
          <span className="px-2 text-sm dark:text-white/70 text-customBlack/70">
            {safePage} / {totalPages}
          </span>
          <button
            type="button"
            onClick={() => onPageChange?.(safePage + 1)}
            className="rounded-md px-2 py-1 text-sm dark:text-white/80 text-customBlack/80 hover:bg-white/10 disabled:opacity-40"
            disabled={!canGoNext}
            aria-label="Next page"
          >
            {'>'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Pagination
